import { WNextBase } from '../api/wnext-base';

interface LiteLLMKeyResponse {
  url: string;
  key: string;
}

export class WNextLiteLLMAPI extends WNextBase {
  async createLiteLLMKey(): Promise<LiteLLMKeyResponse> {
    const res = await this.unwrapRes(await this.client.post('/litellm/team-key'));
    if (res.status !== 'success') {
      throw new Error('Failed to create LiteLLM key');
    }
    return res.data as LiteLLMKeyResponse;
  }
}
